export const getProduct = (slug) => {
  console.log(slug)
  if(!products.hasOwnProperty(slug))
    return products.heliosmax
  return products[slug];
};

const products = {
  heliosmax: {
    slug: "helios-max",
    name: "Helios Max",
    logo: "logo_heliosmax.png",
    subtitle: "Único en el mercado por su formulación al 40%, permitiendo disminuir el volumen aplicado y generando un menor impacto ambiental.",
    img: "bidon.png",
    composition: "Glufosinato de Amonio 40%",
    formula: "Concentrado Soluble (SL).",
    actionMode: "Inhibidor de la glutamino sintetasa",
    uses: [
      {
        title: "Maíz tolerante a Glufosinato de amonio",
        description:
          "Se recomienda aplicar en maíz cuando éste se encuentre entre V4-V6. Las malezas de hoja ancha deberían estar en sus primeros estadios vegetativos y las gramíneas anuales en principio de macollaje.",
      },
      {
        title: "Quemante",
        description:
          "Actúa neutralizando la síntesis de glutamina, acumulándose amoníaco, y al mismo tiempo inhibiendo la fotosíntesis. El primer síntoma es la coloración amarilla clara que adquieren las plantas, las cuales se marchitan y mueren.",
      },
      {
        title: "Doble golpe",
        description:
          "La implementación correcta de la técnica del “doble golpe” es una herramienta eficaz para el control de malezas y contribuye a prevenir la evolución de la resistencia a herbicidas.",
      },
    ],
    essay: "Tecnomyl_EnsayoHelios_Max.pdf",
    technicalFile: "/soluciones",
    usesButtonLabel: "Usos",
    bgHeader: "header.jpg",
    bgHeaderMobile: "header-mobile.jpg",
    bgFooter: "footer.jpg",
    bgFooterMobile: "footer-mobile.jpg",
  },
  guerrer: {
    slug: "guerrer",
    name: "Guerrer",
    logo: "logo_guerrer.png",
    subtitle: "Cultivos libres de malezas desde su inicio.",
    img: "bidon_guerrer.png",
    composition: "Sulfentrazone 50% p/v",
    formula: "Suspensión Concentrada",
    actionMode: "Controla las malezas mediante un proceso de 'disrupción' de membrana",
    uses: [
      {
        title: "Sobresaliente performance a campo.",
        description:
          "Excelente formulación en SC con respaldo calidad Tecnomyl.",
      },
      {
        title: "Alta selectividad en cultivos de soja.",
        description:
          "Con un destacado control de Amaranthus. ",
      },
      {
        title: "Sinergia con otros principios activos.",
        description:
          "Excelente herramienta para el manejo integrado de malezas.",
      },
    ],
    technicalFile: "/downloadFile.php?t=mb&s=guerrer",
    usesButtonLabel: "Usos",
    bgHeader: "bg-header_guerrer.jpg",
    bgHeaderMobile: "bg-header-guerrer_m.jpg",
    bgFooter: "bg-footer_guerrer.jpg",
    bgFooterMobile: "bg-footer-mobile_guerrer.jpg",
  },
};
